import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SegmentedTabs } from '@/components/ds'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { DocumentSequences } from '@/containers/Settings/DocumentSequences/DocumentSequences'
import { DocumentType } from '@/types/DocumentType'

import { EditableZone } from './EditableZone'

export interface InvoicingPreviewSequencesProps {
  onMutate: () => void
  children: React.ReactNode
}

export const InvoicingPreviewSequences = ({
  onMutate,
  children,
}: InvoicingPreviewSequencesProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'settings' })
  const [open, setOpen] = useState(false)
  const [type, setType] = useState<DocumentType>('invoice')

  return (
    <>
      <EditableZone
        onClick={() => setOpen(true)}
        ariaLabel={t('invoicing.preview.sequences.title')}
        className="inline-block w-auto"
      >
        {children}
      </EditableZone>

      <Dialog
        open={open}
        onOpenChange={(isOpen) => {
          setOpen(isOpen)
          if (!isOpen) onMutate()
        }}
      >
        <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-xl">
          <DialogHeader>
            <DialogTitle>{t('invoicing.preview.sequences.title')}</DialogTitle>
            <DialogDescription>
              Formát čísel nových dokladů.
            </DialogDescription>
          </DialogHeader>

          <SegmentedTabs<DocumentType>
            value={type}
            onChange={setType}
            options={[
              { value: 'invoice', label: t('documentSequences.types.invoice.label') },
              { value: 'order', label: t('documentSequences.types.order.label') },
              { value: 'expense', label: t('documentSequences.types.expense.label') },
            ]}
          />

          <DocumentSequences
            key={type}
            type={type}
            onSaveSuccess={type === 'invoice' ? onMutate : undefined}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
